import { mapActions, mapGetters, mapMutations } from "vuex";
import CategoryFilter from "./components/filter/index.vue";
import catalogProduct from "@/components/catalog-product/index.vue";
import Brand from "@/modules/categories/components/brand/index.vue";
import crumbs from "@/modules/card/components/crumbs/index.vue";
import VueRangeSlider from "vue-range-component";
import "vue-range-component/dist/vue-range-slider.css";
import CategorySelect from "../categories/components/select/index.vue";
import VueAdsPagination, { VueAdsPageButton } from "vue-ads-pagination";
import _ from "lodash";
import { dynamicHead } from "../../mixins/dynamic-head";
import { globalLoader } from "../../helpers/variables";
import ca from "vue2-datepicker/locale/es/ca";
import {PRODUCTS_CHANGE_PAGE} from "../../store/mutation-types";

export default {
    name: "categories",
    mixins: [dynamicHead],
    data() {
        return {
            openFilterMenu: false,
            breadCrumbs: [
                { title: "", name: "home", slug: "" },
                { title: this.$t("catalogProduct"), slug: "" },
            ],
            page: 0,
            filterDefaultPrice: false,
            activeSmallerPriceFilter: false,
            minPrice: 0,
            maxPrice: 0,
            value: [],
            filterObj: {},
            typeSort: true,
            h1: this.$t("catalogProduct"),
            sortList: [
                {
                    breadCrumbs: [
                        { title: "", name: "home", slug: "" },
                        { title: this.$t("catalogProduct"), slug: "" },
                    ],
                    name: `${this.$t("sortByPrice")} ↑`,
                    key: "priceUp",
                },
                {
                    name: `${this.$t("sortByPrice")} ↓`,
                    key: "priceDown",
                },
            ],
        };
    },
    components: {
        Brand,
        crumbs,
        CategoryFilter,
        "catalog-product": catalogProduct,
        CategorySelect,
        VueAdsPagination,
        VueAdsPageButton,
        VueRangeSlider,
    },
    computed: {
        ...mapGetters({
            list: "category/listFilter",
            listRequest: "category/listRequest",
            listLoading: "category/listFilterLoading",
            listLength: "category/listFilterLength",
            listMeta: "category/listMeta",
            limit: "category/limit",
            filterCategories: "setting/filterCategories",
            filterCategoriesLoading: "setting/filterCategoriesLoading",
            showFilter: "system/showFilter",
            pageCurrent: "category/page",
            activeCategory: "category/activeCategory",
            products: [],
            smallerPriceFilter: "category/smallerPriceFilter",
            loadingAllProductList: "category/loadingAllProductList",
            categoryList: "category/childCategoryList",
            stateParentCategory: "category/stateParentCategory",
            getCategories: "setting/menu",
            robots: "system/robots",
        }),
        withoutBrand() {
            try {
                return this.filterCategories.attributes.filter(item => item.slug !== "brend");
            } catch (e) {
                return [];
            }
        },
        onlyBrand() {
            try {
                return this.filterCategories.attributes.filter(item => item.slug === "brend");
            } catch (e) {
                return [];
            }
        },
    },
    created() {
        this.value = [];
        this.enableCross = false;
        this.tooltipMerge = false;
        this.formatter = value => `₴${value}`;
        this.processStyle = {
            backgroundColor: "#004AAD",
        };
        this.tooltipStyle = {
            backgroundColor: "#004AAD",
            borderColor: "#004AAD",
        };
        this.bgStyle = {
            backgroundColor: "#5B99EB",
            boxShadow: "inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)",
        };

        if (this.getCategories) {
            this.checkRedirect();
        }

        if (this.activeCategory === this.$route.params.categorySlug) {
            if (this.pageCurrent) {
                this.page = this.pageCurrent - 1;
            }
        } else {
            this.changePage(0);
            this.changeActiveCategory(this.$route.params.categorySlug);
        }
    },
    watch: {
        "$route.params.categorySlug"() {
            this.page = 0;
            this.changePage(1);
            this.fetchFilters({ categorySlug: this.$route.params.categorySlug ? this.$route.params.categorySlug : "" });
            this.generateFilterObj();
            this.updateList();
        },
        filterCategories(newVal) {
            this.changePage(1);
            this.generateFilterObj();
            if (newVal) {
                this.updateList();
            }
        },
        getCategories(val) {
            this.checkRedirect();
        },
        skip() {
            if (this.skip === 0) this.page = 0;
        },
    },
    mounted() {
        if (window.innerWidth < 1251) this.changeOpenFilter(false);
        // this.checkRedirect();
    },
    methods: {
        ...mapActions({
            fetchList: `category/GET_FILTER_PRODUCTS_LIST`,
            fetchListAll: `category/GET_FILTER_PRODUCTS_LIST_ALL`,
            fetchFilters: `setting/GET_CATEGORY_FILTERS`,
            fetchMenu: `setting/GET_CATEGORIES_MENU`,
        }),
        ...mapMutations({
            changePage: `category/PRODUCTS_CHANGE_PAGE`,
            setList: `category/SET_LOADING_FILTER_PRODUCTS_LIST`,
            changeOpenFilter: `system/CHANGE_OPEN_FILTER`,
            changeActiveCategory: `category/ACTIVE_CATEGORY`,
            changeFilterPrice: `category/GET_ACTIVE_PRICE_FILTER`,
            openMobileCategory: "category/SET_MOBILE_CATEGORY",
            productsChangePage: "category/PRODUCTS_CHANGE_PAGE",
        }),

        updateProductList() {
            this.page = 1;
            this.changePage(1);
            this.productsChangePage(1);
            this.generateFilterObj();
            this.updateList().then(() => {
                document.querySelectorAll('.vue-ads-bg-teal-500').forEach(item => item.classList.remove('vue-ads-bg-teal-500'))
                document.querySelector('#app > div.app-container > div > div.wrapper-top > div.content-wrap > div > div.category > div > div > div.category-content > div.category-content__container > div.category-pagination > div > div > div.vue-ads-flex-grow.vue-ads-flex.vue-ads-justify-end > button:nth-child(2)').classList = 'focus:vue-ads-outline-none vue-ads-ml-1 vue-ads-leading-normal vue-ads-w-6 vue-ads-bg-teal-500 vue-ads-text-white vue-ads-cursor-default'
            })
        },

        paginateProductList(page) {
            this.page = page;
            this.generateFilterObj();
            this.updateList();
        },

        checkRedirect() {
            const categoryType = this.getCategoryTypeFromSlug();
            const categoryValue = this.getAllCategoriesFromSlug();
            this.page = 0;
            this.changePage(1);
            this.productsChangePage(1);

            if ( this.$route.params.categorySlug === 'Metaloprokat') {
                const link = this.$router.resolve(this.$linkwrap({name: "categories", params: { categorySlug: 'metaloprokat' }, query: this.$route.query}));
                let head = document.querySelector("head");
                if (!head.querySelector('[name="prerender-status-code"]')) {
                    head.innerHTML += `<meta name="prerender-status-code" content="301">`;
                    head.innerHTML += `<meta name="prerender-header" content="Location: ${window.location.origin}${link.href}">`;
                }
                window.prerenderReady = true;
                setTimeout(() => {
                    window.location.href = `${window.location.origin}${link.href}`;
                }, 150)
            }

            if (!!categoryValue[0] && categoryValue[0].category.childs.length > 0) {
                const link = this.$router.resolve(this.$linkwrap({name: "categories", params: this.$route.params, query: this.$route.query}));
                let head = document.querySelector("head");
                if (!head.querySelector('[name="prerender-status-code"]')) {
                    head.innerHTML += `<meta name="prerender-status-code" content="301">`;
                    head.innerHTML += `<meta name="prerender-header" content="Location: ${window.location.origin}${link.href}">`;
                }
                this.$router.push(
                    this.$linkwrap({
                        name: "category-page",
                        params: this.$route.params,
                        query: this.$route.query,
                    })
                );
            } else {
                if (categoryType !== null) {
                    this.fetchFilters({ categorySlug: this.$route.params.categorySlug ? this.$route.params.categorySlug : "" });
                }
                else {
                    this.fetchFilters({ categorySlug: this.$route.params.categorySlug ? this.$route.params.categorySlug : "" }).then(response => {
                        if (!!response['new-slug']) {
                            const link = this.$router.resolve(this.$linkwrap({name: this.$route.name, params: {...this.$route.params, categorySlug: response['new-slug']}, query: this.$route.query,}));
                            let head = document.querySelector("head");
                            if (!head.querySelector('[name="prerender-status-code"]')) {
                                head.innerHTML += `<meta name="prerender-status-code" content="301">`;
                                head.innerHTML += `<meta name="prerender-header" content="Location: ${window.location.origin}${link.href}">`;
                            }
                            window.prerenderReady = true;
                            setTimeout(() => {
                                window.location.href = `${window.location.origin}${link.href}`;
                            }, 150)
                        }
                        else {
                            if (this.$route.name === "categories" && !!response.data.childs) {
                                const link = this.$router.resolve(this.$linkwrap({ name: "category-page", params: { categorySlug: this.$route.params.categorySlug } }));
                                let head = document.querySelector("head");
                                if (!head.querySelector('[name="prerender-status-code"]')) {
                                    head.innerHTML += `<meta name="prerender-status-code" content="301">`;
                                    head.innerHTML += `<meta name="prerender-header" content="Location: ${window.location.origin}${link.href}">`;
                                }
                                window.prerenderReady = true;
                                setTimeout(() => {
                                    window.location.href = `${window.location.origin}${link.href}`;
                                }, 150)
                            }
                        }
                    });
                }
            }
        },

        generateFilterObj() {
            this.filterObj = {};
            if (this.$route.params.filterSlug) {
                let matchingAttribute = this.filterCategories.attributes.find(attr => {
                    return attr.values.find(val => {
                        return val.slug === this.$route.params.filterSlug;
                    });
                });
                this.filterObj[matchingAttribute.slug] = new Array(this.$route.params.filterSlug);
            }
            if (Object.keys(this.$route.query).length) {
                Object.keys(this.$route.query).map(key => {
                    if (key.startsWith('utm')) return;
                    if (this.filterObj[key]) {
                        this.$route.query[key].split(",").map(item => {
                            this.filterObj[key].push(item);
                        });
                    } else {
                        this.filterObj[key] = this.$route.query[key].split(",");
                    }
                });
            }
        },

        async updateList() {
            console.log('updateList');
            await this.fetchList({
                categorySlug: this.$route.params.categorySlug ? this.$route.params.categorySlug : "all",
                data: { attributes: this.filterObj },
            }).then(response => {
                if (response["new-slug"]) {
                    this.$router.push(
                        this.$localize({
                            name: this.$route.name,
                            params: {
                                ...this.$route.params,
                                categorySlug: response["new-slug"],
                            },
                            query: this.$route.query,
                        })
                    );
                }
                let lastChild;
                let currentChild;
                this.setPageItem(this.listMeta);
                this.minPrice = null;
                this.maxPrice = null;
                this.minPrice = this.filterCategories.price.min;
                this.maxPrice = this.filterCategories.price.max;
                this.value = [];
                this.value.push(this.filterCategories.price.min);
                this.value.push(this.filterCategories.price.max);
                this.breadCrumbs = [
                    { title: "", name: "home", slug: "" },
                    {
                        title: this.$t("catalogProduct"),
                        slug: "",
                    },
                ];
                // Breadcrumbs code
                if (this.filterCategories.parent.parent.title) {
                    this.breadCrumbs.push({
                        name: "category-page",
                        title: this.filterCategories.parent.parent.title,
                        slug: this.filterCategories.parent.parent.slug,
                    });
                    if (this.filterCategories.parent.title) {
                        this.breadCrumbs.push({
                            name: "categories",
                            title: this.filterCategories.parent.title,
                            slug: this.filterCategories.parent.slug,
                        });
                    }
                    if (this.list[0].parents[0].title) {
                        this.breadCrumbs.push({
                            name: "categories",
                            title: this.list[0].parents[0].title,
                            slug: this.list[0].parents[0].slug,
                        });
                    }
                } else {
                    this.breadCrumbs.push({
                        name: "category-page",
                        title: this.filterCategories.parent.title,
                        slug: this.filterCategories.parent.slug,
                    });
                    if (this.list[0].parents[0].title) {
                        if (this.list[0].parents[0].slug === "stok" && !!this.list[0].parents[1]?.title ) {
                            this.breadCrumbs.push({
                                name: "categories",
                                title: this.list[0].parents[1].title,
                                slug: this.list[0].parents[1].slug,
                            });
                        }
                        else {
                            this.breadCrumbs.push({
                                name: "categories",
                                title: this.list[0].parents[0].title,
                                slug: this.list[0].parents[0].slug,
                            });
                        }
                    }
                }
                return response;
            });
        },

        getCategoryFromSlug(slugValue = this.$route.params.categorySlug, categories = this.getCategories) {
            const defaultH1 = this.$t("catalogProduct");

            const searchCategories = categories => {
                for (const category of categories) {
                    if (slugValue === category.slug) {
                        return category;
                    }
                    if (category.childs.length) {
                        const h1 = searchCategories(category.childs);
                        if (h1) return h1;
                    }
                }
                return null;
            };

            return searchCategories(categories) || defaultH1;
        },

        getAllCategoriesFromSlug(slugValue = this.$route.params.categorySlug, categories = this.getCategories) {
            let found = [];

            const searchCategories = (categories, isChild) => {
                for (const category of categories) {
                    if (slugValue === category.slug) {
                        found.push(isChild ? {category: category, type: "child"} : {category: category, type: "main"});
                    }
                    if (category.childs.length) {
                        searchCategories(category.childs, true);
                    }
                }
            };

            if (categories) searchCategories(categories, false);
            return found;
        },

        getCategoryTypeFromSlug(slugValue = this.$route.params.categorySlug, categories = this.getCategories) {
            if (!!categories) {
                const searchCategories = (categories, isChild) => {
                    for (const category of categories) {
                        if (slugValue === category.slug) {
                            return isChild ? "child" : "main";
                        }
                        if (category.childs.length) {
                            const type = searchCategories(category.childs, true);
                            if (type) return type;
                        }
                    }
                    return null;
                };

                return searchCategories(categories, false);
            }
            return null;
        },

        sortPriceRange() {
            this.generateFilterObj();

            if (this.typeSort) {
                this.fetchList({
                    categorySlug: this.$route.params.categorySlug ? this.$route.params.categorySlug : "all",
                    data: { attributes: this.filterObj },
                    sort: "ASC",
                    min: this.value[0],
                    max: this.value[1],
                });
            } else {
                this.fetchList({
                    categorySlug: this.$route.params.categorySlug ? this.$route.params.categorySlug : "all",
                    data: { attributes: this.filterObj },
                    sort: "DESC",
                    min: this.value[0],
                    max: this.value[1],
                });
            }
        },

        toggleFilterMenu() {
            this.openFilterMenu = !this.openFilterMenu;
        },

        sortPriceAsc(   ) {
            this.filterProductsByPrice("ASC");
        },

        sortPriceDesc() {
            this.filterProductsByPrice("DESC");
        },

        sortByCount() {
            this.filterProductsByPrice("");
        },

        filterProductsByPrice(sortOrder) {
            this.generateFilterObj();

            this.fetchList({
                categorySlug: this.$route.params.categorySlug ? this.$route.params.categorySlug : "all",
                data: { attributes: this.filterObj },
                sort: sortOrder,
                min: this.value[0],
                max: this.value[1],
            });
        },

        changePageLocal(page) {
            this.page = page;
            this.changePage(page + 1);
            this.updateList();

            window.scroll({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
        },
    },
};
